<div class="media profile-media">
  <img class="b-r-10" src="assets/images/dashboard/user_profile1.png" width="35" alt="" (click)="misdatos()">
  <div class="media-body" (click)="misdatos()"><span>{{userName}}</span>
    <p class="mb-0 font-roboto">{{historia}}</p>
  </div>
</div>